.legend {
  display: flex;
  gap: var(--space-4);
  font-size: var(--text-xs);
  color: var(--text-secondary);
}

.item {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.swatch {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: var(--color);
}
